// 盤面装飾マップの生成（見栄え用、ゲームロジックには関与しない）
import { BOARD_SIZE } from '../config/board.ts'
import { TILE_WEIGHTS, type TileId, type TileMap } from '../config/tiles.ts'

function pickWeighted(entries: ReadonlyArray<readonly [TileId, number]>): TileId {
  const total = entries.reduce((sum, [, w]) => sum + w, 0)
  let r = Math.random() * total
  for (const [id, w] of entries) {
    r -= w
    if (r <= 0) return id
  }
  return entries[entries.length - 1][0]
}

export function generateMap(): TileMap {
  const entries = Object.entries(TILE_WEIGHTS) as Array<[TileId, number]>
  return Array.from({ length: BOARD_SIZE }, () =>
    Array.from({ length: BOARD_SIZE }, () => pickWeighted(entries))
  )
}
